'use client';
var classes = {"root":"m_d46a4834","inner":"m_b85f7144","fullScreen":"m_96f6e9ad","dropzone":"m_7946116d"};

export { classes as default };
//# sourceMappingURL=Dropzone.module.css.mjs.map
